export default function offRadioButton() {
  const elements = document.getElementsByClassName('customized-radio-button');
  for (let i = 0; i < elements.length; i++) {
    elements[i].checked = false;
  }
}
